<template>
	<div id="payoff" class="flex" :class="{'partner-payoff' : partner}" :style="checkOrderNow ? $route.meta.config.header_background : ''">
		<div class="payoff-outer flex flex-column" :class="checkOrderNow ? 'order-now-outer' : ''">
			<div class="payoff-inner">
				<slot>
					<h1 v-html="partner ? `Prova i Kit Ricette Instacook !` : `Cucina senza sprechi e senza stress con Quomi!`" :class="{'partner-title' : partner}"></h1>
					<h2
						v-if="!partner"
						class="center"
						v-html="subtitle ? subtitle : `Ricevi a casa una box con tutti gli ingredienti freschi e nelle giuste dosi per cucinare cene deliziose`"
					/>
					<h2 
						v-if="partner"
						class="center" 
						style="color: #482826" 
						v-html="`Ogni settimana tante nuove ricette <br> da ricevere e cucinare a casa tua`"
					/>
					<div class="flex-center">
						<router-link :to="{name: 'flow-subscribed'}" v-if="!partner">
							<CTA
								v-if="$route.name !== 'investors'"
								class="button"
								:content="`Ordina ora`"
								isArrow	
							/>
						</router-link>

						<CTA
								v-if="partner"
								class="button"
								:content="`Scegli la tua box`"
								isArrowDown
								@click="activateScroll()"
							/>

						<a
							href="https://www.crowdfundme.it/projects/quomi/" target="_blank"
							v-if="$route.name === 'investors'"
						>
						<CTA
							:content="`Investi ora`"
						/>
						</a>
						<CTA
							v-if="$route.name === 'investors'"
							class="button button-video"
							:content="`<i class='far fa-play-circle'></i> Guarda il video`"
							@click="$emit('openVideo')"
						/>
					</div>
				</slot>
			</div>
			<v-hover v-slot="{ hover }" :class="{'d-none': checkOrderNow || partner}" >
				<v-btn
					class="go-down"
					elevation="3"
					large
					icon
					outlined
					:color="hover ? 'white' : 'var(--quomi-primary)'"
					:style="{ 'background': hover ? 'var(--quomi-primary)' : 'white' }"
					v-if="$mq.isDesktop()"
					@click="scrollToDivId('slider')"
				>
					<i class="fas fa-angle-down fa-2x"/>
				</v-btn>
			</v-hover>
		</div>
	</div>
</template>

<script type="text/javascript">
	import { scrollToElementId } from '../../assets/js/main'

	export default {
		props: {
			subtitle: {
				type: String,
				default: null
			},
			partner: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			checkOrderNow() {
				if(this.$route.name === 'order-now' || this.$route.name === 'order-now-voiello' ) return true
				return false
			}
		},
		methods: {
			activateScroll() {
				this.$emit('scroll-to-div')
				return
			},

			scrollToDivId (target) {
				scrollToElementId(target,300,50)
			},
		}
	}
</script>

<style scoped>
/*payoff*/
#payoff {
	height: 530px;
	background-image: url("/static/cover-box.webp");
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center -5px;
	position: relative;
	text-align: center;
	justify-content: flex-start;
	align-items: center;
}

#payoff .payoff-outer {
	flex-basis: 65%;
	padding: 0 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 13%;
}

#payoff .payoff-inner {
	max-width: 600px;
}

#payoff h1 {
	font-weight: 600;
	font-size: 42px;
	color: #fff 
	/* text-shadow: 3px 3px 7px white; */
	/* font-family: var(--quomi-cursive-font); */
}

#payoff h2 {
	color: white;
	/* text-shadow: 3px 3px 7px white;  */
	font-size: 16px;
	font-weight: 700;
}

#payoff .button {
	margin: 10px;
}

.button-video,
.button-video:hover {
	background-color: white;
	border: 2px solid var(--quomi-primary);
	color: var(--quomi-primary);
}

.go-down {
	position: absolute;
	bottom: 5%;
	left: 50%;
	outline-style: none;
	border: var(--quomi-primary);
}

v-btn--outlined {
  border-color: var(--quomi-primary);
}

.partner-payoff {
	background-image: url("https://api.quomi.it/oldimg/HeaderBennet_sfondochiaro2.webp") !important;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center -3px !important;
}

.partner-title {
	color: #482826 !important;
}

#payoff .order-now-outer {
	margin-top: unset !important;
}

@media only screen and (max-width: 1024px) {
	h2 {
		font-weight: bold;
	}

	#payoff .payoff-outer {
		margin-top: 160px;
		flex-basis: 100%;
		align-self: center;
		margin-bottom: 30px;
	}

	#payoff {	
		background-image: url("/static/cover-box-mobile.webp");
		background-position: center 50%;
	}

	#payoff h1,
	#payoff h2 {
	color: white;
	}

	.partner-payoff {
	background-image: url("https://api.quomi.it/oldimg/HeaderBennet_mobile2.webp") !important;
	background-position: center !important;
}

	#payoff .order-now-outer {
		margin-bottom: unset !important;
	}
}

@media only screen and (max-width: 368px) {
	#payoff h1 {
		font-size: 30px !important;
		padding-top: 10px;
	}

	#payoff h2 {
		font-size: 14px !important;
	}
}

@media only screen and (max-width: 768px) {
	#payoff {	
		height: 500px;
	}
	
	#payoff h1 {
		font-size: 35px;
	}

	.partner-title {
	font-size: 27px !important;
}

}

@media only screen and (min-width: 768px) {
	#payoff h2 {
		font-size: 18px;
	}

@media only screen and (min-width: 1920px) {
#payoff {
	min-height: 85vh;
}
}

}

</style>